<template>
    <div class="mailing_panel">
        <div class="mailing_header">
            <h3 class="mailing_title mailing_text_color__darkBlue">Текущие рассылки</h3>
            <new-button
                @click="() => mailingStore.setIsSettings(true)"
                :buttonColoring="'blue'"
            >
                Добавить новую рассылку
            </new-button>
        </div>
        <CurrentMailingsTable />
    </div>
</template>

<script>
import CurrentMailingsTable from './CurrentMailingsTable.vue';
import newButton from "@/shared/newButton.vue";
import { useMailingStore } from "@/stores/MailingStore";

export default {
    name: "CurrentMailings",
    setup() {
        const mailingStore = useMailingStore();
        return {
            mailingStore
        }
    },
    components: {
        CurrentMailingsTable,
        newButton
    },
}
</script>
